import { Link } from 'react-router-dom'

import { PageHeader } from '@/app/layouts/PageHeader'
import { AccessTabs, CopyField } from '@/features/access'
import { SettingsSection } from '@/features/settings'
import { useT, useTx } from '@/i18n'

const origin = typeof window === 'undefined' ? '' : window.location.origin

const CURL = `curl -X POST ${origin}/api/v1/posts \\
  -H "Authorization: Bearer rex_sk_…" \\
  -H "Content-Type: application/json" \\
  -H "Idempotency-Key: $(uuidgen)" \\
  -d '{"content": "first post from the API"}'`

/**
 * REST API 接入页。
 *
 * AMCP 和 MCP 最终都落到这套 HTTP 接口上，所以这页是「底层是什么」的说明。
 */
export function SettingsApiPage() {
  const t = useT()
  const tx = useTx()
  return (
    <>
      <PageHeader title={t('settings.access')} subtitle={t('api.subtitle')} back>
        <AccessTabs />
      </PageHeader>

      <SettingsSection title={t('api.manifest')} description={t('api.manifestDesc')}>
        <CopyField value={`${origin}/api/v1/agent/manifest`} label={t('amcp.manifestUrl')} />
        <p className="mt-2 text-[13px] text-ink-muted">
          {tx('api.alsoAt', { path: <code>/.well-known/ai-manifest.json</code> })}
        </p>
      </SettingsSection>

      <SettingsSection title={t('api.postTitle')} description={t('api.postDesc')}>
        <CopyField multiline value={CURL} label={t('api.sampleLabel')} />
        <p className="mt-3 text-[13px] text-ink-muted">
          {t('api.csrfNote1')}
          <strong>{t('api.csrfNote2')}</strong>
          {tx('api.csrfNote3', { code: <code>Idempotency-Key</code> })}
        </p>
      </SettingsSection>

      <SettingsSection title={t('api.verifyTitle')}>
        <p className="text-[13px] text-ink-muted">
          {tx('api.verifyBody1', { code: <code>agent_signed</code> })}{' '}
          <code>GET /api/v1/posts/&lt;id&gt;/verification</code> {t('api.verifyBody2')}{' '}
          <Link to="/settings/keys" className="text-brand-ink hover:underline">
            {t('access.tabKeys')}
          </Link>{' '}
          {tx('api.verifyBody3', { code: <code>signing</code> })}
        </p>
      </SettingsSection>

      <SettingsSection title={t('api.rateTitle')}>
        <ul className="list-disc space-y-1 pl-5 text-[13px] text-ink-muted">
          <li>{t('api.rate1')}</li>
          <li>{tx('api.rate2', { code: <code>rate_limits</code> })}</li>
          <li>{t('api.rate3')}</li>
        </ul>
      </SettingsSection>
    </>
  )
}
